import React, { useState } from 'react';
import Dialog from '../../../components/Dialog';
import { IconPlus } from '../../../components/dialogIcons';

/*
  A line for something the catalog does not know about.

  Ported onto the shared dialog shell on 5 September 2026, to Group E's approved
  drawing `dialog-custom-item-*.png`.

  **The asterisks are gone and the sentence says what they meant.** Three fields
  marked `*` with a line underneath explaining that fields marked `*` are
  required is the form explaining its own punctuation. The drawing says it once,
  in words: an admin has to be able to identify this later, so all three are
  needed.
*/
export default function CustomItemModal({ location, initialValue, onSave, onClose, showQty = false }) {
  const [form, setForm] = useState({
    itemNumber:  (initialValue || '').toUpperCase(),
    description: '',
    vendor:      '',
    location:    '',
    quantity:    1,
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const ready = form.itemNumber.trim() && form.description.trim() && form.vendor.trim();

  async function handleSave() {
    if (!ready || saving) return;
    setSaving(true);
    await onSave({ ...form, quantity: showQty ? (form.quantity || 1) : 0 });
    setSaving(false);
  }

  return (
    <Dialog
      kind="info" icon={<IconPlus />}
      title="Add an item that is not in the catalog"
      record={location}
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={!ready || saving}>
            {saving ? 'Adding...' : 'Add to the count'}
          </button>
        </>
      }
    >
      <div style={{ background: 'var(--warning-bg)', borderRadius: 12, padding: '12px 14px', fontSize: 13, color: 'var(--warning-ink)', lineHeight: 1.55 }}>
        Item number, description and vendor are all needed, so an admin can identify it later. It goes
        on the sheet flagged for checking.
      </div>

      <div className="form-lbl">Item number</div>
      <input className="form-inp" placeholder="e.g. A-W0200BLK" autoFocus
        value={form.itemNumber} onChange={e => set('itemNumber', e.target.value.toUpperCase())} />

      <div className="form-lbl">Description</div>
      <input className="form-inp" placeholder="e.g. WALKING BOOT - AIR EQ - STANDARD - XS"
        value={form.description} onChange={e => set('description', e.target.value.toUpperCase())} />

      <div className="form-lbl">Vendor</div>
      <input className="form-inp" placeholder="e.g. OSSUR"
        value={form.vendor} onChange={e => set('vendor', e.target.value.toUpperCase())} />

      <div className="form-lbl">Item location</div>
      <input className="form-inp" placeholder="Optional. e.g. Shelf A3, Drawer 2"
        value={form.location} onChange={e => set('location', e.target.value)} />

      {showQty && (
        <>
          <div className="form-lbl">Quantity</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button type="button" className="btn btn-quiet" style={{ width: 44, minHeight: 44, padding: 0, fontSize: 20 }}
              onClick={() => set('quantity', Math.max(1, (form.quantity || 1) - 1))}>-</button>
            <input type="number" min="1" value={form.quantity}
              onChange={e => set('quantity', Math.max(1, parseInt(e.target.value, 10) || 1))}
              style={{ flex: 1, padding: '10px', border: '2px solid var(--action)', borderRadius: 'var(--oh-radius-control)', textAlign: 'center', fontSize: 20, fontWeight: 800, fontFamily: 'inherit', outline: 'none', MozAppearance: 'textfield', WebkitAppearance: 'none', appearance: 'none' }} />
            <button type="button" className="btn btn-quiet" style={{ width: 44, minHeight: 44, padding: 0, fontSize: 20 }}
              onClick={() => set('quantity', (form.quantity || 1) + 1)}>+</button>
          </div>
        </>
      )}
    </Dialog>
  );
}
